//Este archivo es llamado para "armar" los placeholders del docx en caso esten rotos
export function reconstruirPlaceholdersXml(xml) {
  let result = ''
  let i = 0
  let dentroTag = false
  let dentroPlaceholder = false
  let placeholder = ''
  const placeholders = []

  // Fase 1: Recorrer caracter a caracter
  while (i < xml.length) {
    const char = xml[i]

    // Detectar entrada y salida de una etiqueta XML
    if (char === '<') {
      dentroTag = true
      result += char
      i++
      continue
    } else if (char === '>' && dentroTag) {
      dentroTag = false
      result += char
      i++
      continue
    }

    // Si estamos dentro de una etiqueta XML, copiar directo
    if (dentroTag) {
      result += char
      i++
      continue
    }

    // Detección de inicio de placeholder
    if (!dentroPlaceholder && char === '$' && xml[i + 1] === '{') {
      dentroPlaceholder = true
      placeholder = '${'
      i += 2
      continue
    }

    // Si estamos leyendo un placeholder
    if (dentroPlaceholder) {
      placeholder += char
      if (char === '}') {
        placeholders.push({
          tag: placeholder,
          start: result.length,
        })
        result += placeholder
        dentroPlaceholder = false
        placeholder = ''
      }
      i++
      continue
    }

    // Texto normal
    result += char
    i++
  }

  return result
}